import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Success' },
    { value: 2, label: 'Error' },
    { value: 3, label: 'Not Subscribed' },
    { value: 4, label: 'Permission Denied' },
  ],
});
